/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from "../../core/IceEntity";

export class reviewer extends IceEntity {
  reviewer_key: string = "";
  reviewed_by: string = "";
  reviewed_date: any = NaN;
  comment: string = "";
  title_of_reviewer: string = "";
  data_to_sign: string = "";
  token: string = "";
  issued: any = NaN;
  expired: any = NaN;
  review_terminated: any = NaN;
  review_terminated_comment: string = "";
  review_terminated_token: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  signature_data: string = "";

  public gettablename(): string {
    return "REVIEWER";
  }
}
